import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
let KlookPageTitle = class KlookPageTitle extends Vue {
};
__decorate([
    Prop(String)
], KlookPageTitle.prototype, "title", void 0);
KlookPageTitle = __decorate([
    Component
], KlookPageTitle);
export default KlookPageTitle;
